module.exports = {
    login:'Login',
    taption: 'Taption',
    ways_to_use_taption:'Ways to use Taption',
    faq:'FAQ',
    pricing:'Pricing',
    language:'Language',
    product:'Products'
  }
  